<template>
    <v-card class="group-deal-card my-5 mx-5" @click="viewGroupDeal">
        <v-img v-if="dealPhoto" class="deal-photo" :src="dealPhoto" />
        <v-card class="group-deal-no-image" v-else>
            <h2>No Image</h2>
        </v-card>
        <span>{{ dealData.dealName }} ({{ dealData.groupSize }})</span>
    </v-card>
</template>

<style scoped>
.deal-photo {
    height: 85%;
    background-color: grey;
    border-radius: 5px;
}
</style>

<script>
export default {
    props: {
        dealData: {
            type: Object,
            default: () =>{
                return {};
            }
        }
    },
    methods: {
        viewGroupDeal(){
            this.$emit('view-group-deal', this.dealData);
        }
    },
    computed: {
        dealPhoto(){
            return this.dealData.dealPhoto ?
                this.dealData.dealPhoto.photoData ?
                this.dealData.dealPhoto.photoData : this.dealData.dealPhoto : null;
        }
    }
}
</script>
